import { Deployment } from '@/types/deployment';
import { getDeploymentUrl } from '@/utils/deploymentUrl';
import { Services } from '../enums/services';

type Host = {
    path: Services;
    url: string;
};

const hosts: Host[] = [
    {
        path: Services.WavebidV2,
        url: 'https://DEPLOYMENT.proxibid.com/api/v2/API_PATH',
    },
    {
        path: Services.SellerPortal,
        url: 'https://DEPLOYMENT.proxibid.com/api/v3/API_PATH',
    },
    {
        path: Services.Classic,
        url: 'https://DEPLOYMENT.proxibid.com/API_PATH',
    },
    {
        path: Services.Local,
        url: '/API_PATH',
    },
];

type BuildUrlProps = {
    apiPath: string;
    apiService: Services;
    deployment: Deployment;
    params?: any;
};

/**
 * Builds a complete API URL based on service and environment
 * @param apiPath - API endpoint path
 * @param apiService - Service to call (Classic or WavebidV2)
 * @param deployment - Deployment environment
 * @param params - Optional URL parameters to append
 * @returns Complete URL string for the API request
 */
export const buildUrl = ({ apiPath = '', apiService, deployment, params = {} }: BuildUrlProps) => {
    let updatedPath = '';

    hosts.forEach((host) => {
        if (Boolean(apiService.includes(host.path))) {
            const url = getDeploymentUrl({ apiService, deployment, path: host.url });
            updatedPath = apiService.replace(host.path, url);
            updatedPath = updatedPath.replace('API_PATH', apiPath);
        }
    });

    const searchParams = new URLSearchParams(params).toString();

    return `${updatedPath}${Boolean(searchParams) ? `?${searchParams}` : ''}`;
};
